import { n as c } from "./property-9daa16cd.mjs";
import { i as h, E as p, x as g, d as u } from "./createReactComponent-58f9bea8.mjs";
import { e as m } from "./class-map-2994e95e.mjs";
const d = h`
  :host .avatar {
    position: relative;
    align-items: center;
    justify-content: center;
    user-select: none;
    display: flex;
    visibility: hidden;
    font: var(--exo-text-label-medium-bold);
    color: var(--exo-color-font);
    box-sizing: border-box;
    border-radius: var(--exo-spacing-3x-small);
  }

  :host .avatar.size--large {
    width: 40px;
    height: 40px;
  }

  :host .avatar.size--small {
    width: 32px;
    height: 32px;
    font-size: var(--exo-font-size-small);
  }

  :host .avatar.avatar--account {
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-small);
  }

  :host .avatar.avatar--user {
    border-radius: var(--exo-radius-circle);
    padding: var(--exo-spacing-x-small);
  }

  :host .avatar.avatar--set-1-1 {
    background-color: var(--exo-palette-coral-50);
    color: var(--exo-palette-navy-80);
  }

  :host .avatar.avatar--set-1-2 {
    background-color: var(--exo-palette-navy-70);
    color: var(--exo-palette-white);
  }

  :host .avatar.avatar--set-1-3 {
    background-color: var(--exo-palette-purple-50);
    color: var(--exo-palette-white);
  }

  :host .avatar.avatar--set-1-4 {
    background-color: var(--exo-palette-periwinkle-50);
    color: var(--exo-palette-white);
  }

  :host .avatar.avatar--set-1-5 {
    background-color: var(--exo-palette-blue-60);
    color: var(--exo-palette-white);
  }

  :host .avatar.avatar--set-1-6 {
    background-color: var(--exo-palette-navy-10);
    color: var(--exo-palette-navy-80);
  }

  :host .avatar.avatar--set-1-7 {
    background-color: var(--exo-color-background);
    border: 1px solid var(--exo-palette-coral-50);
  }

  :host .avatar.avatar--visible {
    visibility: visible;
  }
`;
var x = Object.defineProperty, y = Object.getOwnPropertyDescriptor, v = (r, t, a, e) => {
  for (var l, o = e > 1 ? void 0 : e ? y(t, a) : t, n = r.length - 1; n >= 0; n--)
    (l = r[n]) && (o = (e ? l(t, a, o) : l(o)) || o);
  return e && o && x(t, a, o), o;
}, b = ((r) => (r.ACCOUNT = "account", r.USER = "user", r))(b || {}), C = ((r) => (r.SMALL = "small", r.LARGE = "large", r))(C || {});
const s = { CORAL: "set_1_1", NAVY: "set_1_2", PURPLE: "set_1_3", PERIWINKLE: "set_1_4", BLUE: "set_1_5", GRAY: "set_1_6", WHITE: "set_1_7" };
class i extends p {
  constructor() {
    super(...arguments), this.avatarType = "account", this.accountName = "", this.firstName = "", this.lastName = "", this.size = "large";
  }
  getVisibility() {
    let t = !1;
    return this.avatarType === "account" ? this.accountName.trim().length !== 0 && (t = !0) : this.avatarType === "user" && this.firstName.trim().length !== 0 && (t = !0), t;
  }
  getColor() {
    let t = "set_1_1";
    if (this.avatarType === "account") {
      const a = this.accountName.trim();
      if (a.length >= 2) {
        const e = (a.charCodeAt(a.length - 1) + a.charCodeAt(a.length - 2)) % 7;
        t = Object.values(s)[e];
      }
    } else if (this.avatarType === "user") {
      const a = this.firstName.trim().charAt(0).toUpperCase(), e = this.lastName.trim().toUpperCase(), l = e.charAt(e.length - 1);
      if (l.length === 0) {
        const o = a.charCodeAt(0) % 7;
        t = Object.values(s)[o];
      } else {
        const o = (a.charCodeAt(0) + l.charCodeAt(0)) % 7;
        t = Object.values(s)[o];
      }
    }
    return t;
  }
  getText() {
    let t = "";
    if (this.avatarType === "account")
      t = this.accountName.trim().charAt(0).toUpperCase();
    else if (this.avatarType === "user") {
      const a = this.firstName.trim(), e = this.lastName.trim();
      t = e.length === 0 ? a.charAt(0).toUpperCase() : a.charAt(0).toUpperCase().concat(e.charAt(0).toUpperCase());
    }
    return t;
  }
  render() {
    return g`<div
      class=${m({ avatar: !0, "avatar--account": this.avatarType === "account", "avatar--user": this.avatarType === "user", "avatar--set-1-1": this.getColor() === s.CORAL, "avatar--set-1-2": this.getColor() === s.NAVY, "avatar--set-1-3": this.getColor() === s.PURPLE, "avatar--set-1-4": this.getColor() === s.PERIWINKLE, "avatar--set-1-5": this.getColor() === s.BLUE, "avatar--set-1-6": this.getColor() === s.GRAY, "avatar--set-1-7": this.getColor() === s.WHITE, "avatar--visible": this.getVisibility(), "size--large": this.size === "large", "size--small": this.size === "small" })}
      aria-hidden="${!this.getVisibility()}"
    >
      ${this.getText()}
    </div>`;
  }
}
i.styles = d, v([c({ type: String })], i.prototype, "avatarType", 2), v([c({ type: String })], i.prototype, "accountName", 2), v([c({ type: String })], i.prototype, "firstName", 2), v([c({ type: String })], i.prototype, "lastName", 2), v([c({ type: String })], i.prototype, "size", 2);
const _ = u("ex-avatar", i);
export {
  b as A,
  C as a,
  i as b,
  _ as r
};
